<script>
  import { mapState ,mapActions } from "vuex";
  export default {
    name: "ValoresCultura",
    data() {
      return {
        cargando: false
      };
    },
    computed:{
        ...mapState("CulturaModule", ["culturas"]), 
    },
    created() {
      this.getCulturaEmpresa();
    },
    methods: {
      ...mapActions("CulturaModule", ["getCultura"]),
      async getCulturaEmpresa() {
        let data_ = {
          id_empresa: this.$ls.get("user").id_empresa_fk, 
        }
        await this.getCultura(data_);
        this.cargando = true;
      },

      //FF
      capturarValor(valor) {
        this.$emit("valorCapturado", valor);
      }
    }
  };
</script>

<template>   
  <div 
    v-if="cargando" 
    class="mt-3"
  >
    <div 
      v-for="valor in culturas.valores" :key="valor.id_valor" 
      class="row mb-3"
    >
      <div class="col-12">
        <a
          href="javascript:"
          data-bs-toggle="modal"
          data-bs-target="#modal-valor"
          @click="capturarValor(valor)"
          class="d-flex"
        >
        <div class="d-flex align-items-center">
          <div class="flex-shrink-0">
            <img
              v-if="valor.imagen_url && /.jpg|.jpeg|.png/.test(valor.imagen_url)"
              :src="valor.imagen_url"
              width="70"
              height="70"
              class="img-object-cover rounded-circle card-shadow"
              :alt="valor.nombre"
            />

            <img
              v-else
              width="70"
              height="70"
              class="img-object-cover rounded-circle border border-white p-1"
              src="@/assets/img/intranet/cultura/img-default-twu.png"
              :alt="valor.nombre"
            />
          </div>
          <div class="flex-grow-1 ms-3">
            <h3 class="font-700 mb-0 color-main">
              {{ valor.nombre }}
            </h3>
          </div>
        </div>
      </a>
      </div>
    </div>
  </div>
</template>
